import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '..';
import jwt_decode from 'jwt-decode';
import { $authHost } from './index'; // Подключаем $authHost для работы с API
import {fetchInitialMessagesAPI} from "./ServerAPI";

let socketInstance = null; // Singleton для WebSocket

class WebSocketService {
    constructor() {
        this.socket = null;
        this.requestedChats = new Set();
    }

    setupWebSocket(token, user) {
        if (this.socket) {
            this.socket.close(); // Закрываем существующее соединение
        }

        this.socket = new WebSocket(`wss://scraplands.ru:4093?token=${token}`);

        this.socket.onopen = () => {
            console.log('Соединение установлено');
        };

        this.socket.onmessage = async (event) => {
            let data;
            try {
                data = JSON.parse(event.data);
            } catch (e) {
                console.error("Ошибка парсинга JSON из WebSocket:", event.data);
                return;
            }
            if (data.type === "ping") {
                this.socket.send(JSON.stringify({ type: "pong" }));
            } else if (data && data.chat !== undefined) {
                console.log("Получено сообщение для чата:", data.chat, data);
                const chatId = data.chat;
                /*if (!this.requestedChats.has(chatId)) {
                    try {

                        const initialMessages = await fetchInitialMessagesAPI(chatId);
                        const initialChatData = {
                            chat: chatId,
                            data: initialMessages // Предполагаем, что initialMessages - это массив сообщений
                        };
                        user.setChat(initialChatData); // Сохраняем начальные сообщения в стор

                    } catch (error) {
                        console.error(`Ошибка загрузки начальных сообщений для чата ${chatId}:`, error);
                        // Можно установить флаг ошибки или показать уведомление
                    }
                }*/
                let messagesToAdd = [];
                if (Array.isArray(data.data)) {
                    messagesToAdd = data.data;
                } else if (data.data && typeof data.data === 'object') {
                    messagesToAdd = [data.data];
                } else {
                    console.warn("Неожиданный формат данных сообщения:", data.data);
                }

                if (messagesToAdd.length > 0) {
                    const newChatData = {
                        chat: data.chat,
                        data: messagesToAdd, // Передаем массив сообщений
                    };
                    console.log("Добавляем новые сообщения в стор:", newChatData);
                    user.setChat(newChatData);
                }
            } else {
                // Обработка других типов сообщений, если есть
                console.log("Получено другое сообщение WebSocket:", data);
            }


        };

        this.socket.onclose = () => {
            console.log('Соединение закрыто');
            setTimeout(() => this.reconnect(user), 5000); // Переподключаемся через 5 секунд
        };

        this.socket.onerror = async (error) => {
            console.error('Ошибка WebSocket', error);

            if (error.message.includes('401')) {
                try {
                    const { data } = await $authHost.post('api/v1/refresh.php', {}, { withCredentials: true });
                    const newToken = data.access_token;
                    if (newToken) { // Проверяем, есть ли токен в ответе
                        localStorage.setItem('token', newToken);
                        this.setupWebSocket(newToken, user);
                    } else {
                        console.error('Токен обновления не получен');
                    }
                } catch (refreshError) {
                    console.error('Ошибка обновления токена', refreshError);
                }
            }
        };
    }

    reconnect(user) {
        const token = localStorage.getItem('token');
        if (token) {
            this.setupWebSocket(token, user);
        } else {
            console.log('Токен не найден, переподключение невозможно');
        }
    }
}

export const getWebSocketInstance = (user) => {
    if (!socketInstance) {
        socketInstance = new WebSocketService();
    }
    return socketInstance;
};

const WsUserAPI = observer(() => {
    const { user } = useContext(Context);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const webSocket = getWebSocketInstance(user);
            webSocket.setupWebSocket(token, user);
        }

        return () => {
            if (socketInstance?.socket) {
                socketInstance.socket.close();
            }
        };
    }, [user]);

    return null;
});

export default WsUserAPI;
